import(/* webpackMode: "eager" */ "/codebuild/output/src2447117988/src/monorepo/apps/web/src/app/components/Pages/ContentPage.tsx")